import { useParams } from 'react-router-dom';
import { useFetch } from '../../hook/useFetch';

import './style.css';

export const Profile = () => {
  let { r_id } = useParams();

  const { data, isLoading, hasError } = useFetch('registro/' + r_id);
  console.log(data);
  console.log(hasError);

  return (
    <>
      <div className="breadcrumb-banner-area">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcrumb-text">
                <h1 className="text-center">Perfil de registro</h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="contact-form-area section-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-12">
              <h4 className="contact-title">Información de registro</h4>
              {isLoading && <div>Cargando...</div>}
              {hasError && (
                <div>Ha ocurrido un error al cargar los datos...</div>
              )}
              {!hasError && !isLoading && (
                <>
                  <div className="row">
                    <div className="col-lg-8">
                      <p>
                        Nombre: <span className="data"> {data.r_nombre}</span>
                      </p>
                      <p>
                        Primer apellido:
                        <span className="data"> {data.r_primer_apellido}</span>
                      </p>
                      <p>
                        Segundo apellido:
                        <span className="data"> {data.r_segundo_apellido}</span>
                      </p>
                      <p>
                        Correo: <span className="data"> {data.r_correo}</span>
                      </p>
                      <p>
                        Sexo: <span className="data"> {data.r_sexo}</span>
                      </p>
                      <p>
                        Celular: <span className="data"> {data.r_celular}</span>
                      </p>
                      <p>
                        Institución:
                        <span className="data"> {data.r_institucion}</span>
                      </p>
                      <p>
                        Puesto: <span className="data"> {data.r_puesto}</span>
                      </p>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
